import { getEmployeesQueryData, getUserQueryData } from '@sit/client-shared';
import { queryClient } from '@web/query-client';
import isEqual from 'lodash/isEqual';
import { all, call, put } from 'redux-saga/effects';
import api from '../../helpers/api';
import { fetchQueryTimesheetRows } from '../../hooks/api';
import { selectToken } from '../selectors';
import { store } from '../store';
import { setSyncStatus } from '../timesheets-slice';
import * as actions from './actions';
import { GenerateRowAutofill, HandleAutofillValues } from './helpers';

export function* createTimesheetRowRequestSaga(payload) {
  try {
    const _store = store.getState();
    const userData = getUserQueryData(queryClient);
    const token = selectToken(_store);
    const res = yield api.send({
      url: `/timesheets/${payload.data.timesheetId}/rows${payload.data.staff ? '?staff=true' : ''}`,
      method: 'POST',
      data: payload.data.data,
      token,
    });
    let userAutofillValues = [];
    const userIdOfTimesheet = payload.data.userId || payload.data.timesheetUserId;
    if (userData?.id === userIdOfTimesheet) {
      userAutofillValues = userData?.autofillValues;
    } else {
      // this is a staff timesheet, need to get the autofill values from the timesheet user
      // yield put(EmployeesActions.getEmployeesRequest({}));
      const employeesData = getEmployeesQueryData(queryClient);
      let timesheetUser;
      for (const [queryKey, queryData] of employeesData) {
        // ['employees']
        if (queryKey.length === 1) {
          timesheetUser = queryData?.employees.find((u) => u.employeeId === payload.data.employeeId);
          if (timesheetUser) break;
        }
      }
      userAutofillValues = timesheetUser?.autofillValues;
    }
    if (userAutofillValues && userAutofillValues.length > 0) {
      yield HandleAutofillValues({ autofillValues: userAutofillValues, rowId: res.id, from: 'user' });
    }
    yield put(actions.createTimesheetRowRequestSuccess(res));
    yield put(actions.getTimesheetRowRequest({ timesheetId: payload.data.timesheetId }));
    yield put(setSyncStatus({ timesheetId: payload.data.timesheetId, synced: false }));
  } catch (error) {
    yield put(actions.createTimesheetRowRequestFailure(error));
  }
}

export function* getTimesheetRowRequestSaga(payload) {
  try {
    const _store = store.getState();
    const res = yield api.send({
      url: `/timesheets/${payload.data.timesheetId}/rows/${payload.data.rowId}`,
      method: 'GET',
      token: selectToken(_store),
    });
    yield call(GenerateRowAutofill, { res, store: _store });
    yield put(actions.getTimesheetRowRequestSuccess(res));
  } catch (error) {
    yield put(actions.getTimesheetRowRequestFailure(error));
  }
}

export function* getTimesheetRowsRequestSaga(payload) {
  try {
    const _store = store.getState();
    const existingTimesheetRows = _store.timesheetRows.data || [];
    const timesheetRows = yield fetchQueryTimesheetRows({ timesheetId: payload.data.timesheetId }, selectToken(_store));
    // Compare existingTimesheetRows to timesheetRows
    const rowsToUpdateAutofills = [];
    for (const newRow of timesheetRows) {
      const existingRow = existingTimesheetRows.find((row) => row.id === newRow.id);

      if (!existingRow || !isEqual(newRow, existingRow)) {
        // If the row is new or updated, perform GenerateRowAutofill
        rowsToUpdateAutofills.push(newRow);
      }
    }

    yield all(rowsToUpdateAutofills.map((row) => call(GenerateRowAutofill, { row, store: _store })));
    yield put(actions.getTimesheetRowsRequestSuccess(timesheetRows));
  } catch (error) {
    yield put(actions.getTimesheetRowsRequestFailure(error));
  }
}
